import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode, Company, EmployeeId } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';

export function paramPayment() {
    let url = 'timesheet/paramPay?' + objectToQueryString({
        userCode: UserCode(),
        company: Company(),
        employeeId: EmployeeId(),
        token: Token()
    });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}